"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const ZoomableContainer = _ref => {
  let {
    backgroundColor = '#FFFFFF',
    children,
    color,
    height = 'auto',
    onDoubleClick,
    onZoomChange,
    width = 'auto',
    zoomInterval = 0.3
  } = _ref;
  const {
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const parsedColor = color !== null && color !== void 0 ? color : primaryColor;
  const [dragging, setDragging] = (0, _react.useState)(false);
  const [origin, setOrigin] = (0, _react.useState)({
    x: 0,
    y: 0
  });
  const [position, setPosition] = (0, _react.useState)({
    x: 0,
    y: 0
  });
  const [zoom, setZoom] = (0, _react.useState)(1);
  const zoomableDivRef = (0, _react.useRef)(null);
  const handleDoubleClick = e => {
    if (!onDoubleClick) return;
    const rect = zoomableDivRef.current.getBoundingClientRect();
    onDoubleClick({
      x: parseInt((e.clientX - rect.left) / zoom, 10),
      y: parseInt((e.clientY - rect.top) / zoom, 10)
    });
  };
  const handleMouseDown = e => {
    setDragging(true);
    setOrigin({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
    e.stopPropagation();
  };
  const handleMouseMove = e => {
    if (!dragging) return;
    setPosition({
      x: e.clientX - origin.x,
      y: e.clientY - origin.y
    });
    e.stopPropagation();
  };
  const handleMouseUp = () => {
    setDragging(false);
  };
  const handleZoomIn = () => {
    setZoom(prevZoom => {
      const newZoom = prevZoom + zoomInterval;
      onZoomChange && onZoomChange(newZoom);
      return newZoom;
    });
  };
  const handleZoomOut = () => {
    setZoom(prevZoom => {
      const newZoom = Math.max(zoomInterval, prevZoom - zoomInterval);
      onZoomChange && onZoomChange(newZoom);
      return newZoom;
    });
  };
  const buttonsContainerProps = {
    color: parsedColor
  };
  const componentContainerProps = {
    backgroundColor,
    color: parsedColor,
    height,
    width
  };
  const containerProps = {
    cursor: dragging ? 'grabbing' : 'grab',
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onMouseLeave: handleMouseUp
  };
  const contentProps = {
    onDoubleClick: handleDoubleClick,
    height: 'auto',
    left: "".concat(position.x, "px"),
    ref: zoomableDivRef,
    top: "".concat(position.y, "px"),
    width: 'auto',
    zoom
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.ComponentContainer, _objectSpread(_objectSpread({
    "data-testid": "ComponentContainer"
  }, componentContainerProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Container, _objectSpread(_objectSpread({
      "data-testid": "Container"
    }, containerProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Content, _objectSpread(_objectSpread({
        "data-testid": "Content"
      }, contentProps), {}, {
        children: children
      }))
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.ButtonsWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.ButtonsContainer, _objectSpread(_objectSpread({
        "data-testid": "ButtonsContainer"
      }, buttonsContainerProps), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          color: parsedColor,
          icon: "remove",
          onClick: handleZoomOut
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          color: parsedColor,
          icon: "add",
          onClick: handleZoomIn
        })]
      }))
    })]
  }));
};
ZoomableContainer.propTypes = {
  backgroundColor: _propTypes.default.string,
  children: _propTypes.default.any,
  color: _propTypes.default.string,
  height: _propTypes.default.string,
  onDoubleClick: _propTypes.default.func,
  onZoomChange: _propTypes.default.func,
  width: _propTypes.default.string,
  zoomInterval: _propTypes.default.number
};
var _default = exports.default = ZoomableContainer;